import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

const booleanToSelectValue = (value) => {
  if (value === true) {
    return "YES";
  }

  if (value === false) {
    return "NO";
  }

  return "";
};

const selectValueToBoolean = (value) => {
  if (value === "YES") {
    return true;
  }

  if (value === "NO") {
    return false;
  }

  return null;
};

const NullableBooleanSelect = ({
  label,
  value,
  onChange,
  disabled = false,
  fullWidth = true,
}) => {
  return (
    <FormControl
      fullWidth={fullWidth}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>

      <Select
        value={booleanToSelectValue(value)}
        label={label}
        onChange={(event) =>
          onChange(
            selectValueToBoolean(
              event.target.value,
            ),
          )
        }
      >
        <MenuItem value="">
          Not assessed
        </MenuItem>

        <MenuItem value="YES">
          Yes
        </MenuItem>

        <MenuItem value="NO">
          No
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default NullableBooleanSelect;